// Saudi Arabia administrative regions and their main cities (English labels).
// Used by the hotline patient registration Region/City dropdowns.

export const SAUDI_REGIONS = [
  "Riyadh",
  "Makkah",
  "Madinah",
  "Eastern Province",
  "Asir",
  "Tabuk",
  "Hail",
  "Northern Borders",
  "Jazan",
  "Najran",
  "Al Bahah",
  "Al Jawf",
  "Qassim",
];

export const SAUDI_CITIES = {
  Riyadh: ["Riyadh", "Diriyah", "Al Kharj", "Al Majma'ah", "Az Zulfi", "Wadi ad-Dawasir", "Al Quwayiyah", "Afif", "Dawadmi", "Shaqra"],
  Makkah: ["Makkah", "Jeddah", "Taif", "Rabigh", "Al Qunfudhah", "Al Lith", "Khulais", "Turbah"],
  Madinah: ["Madinah", "Yanbu", "Al Ula", "Badr", "Khaybar", "Al Henakiyah", "Mahd adh Dhahab"],
  "Eastern Province": ["Dammam", "Al Khobar", "Dhahran", "Al Ahsa (Hofuf)", "Jubail", "Qatif", "Ras Tanura", "Hafar Al-Batin", "Khafji", "Abqaiq"],
  Asir: ["Abha", "Khamis Mushait", "Bisha", "Mahayil", "Sarat Abidah", "Tathlith", "Al Namas", "Ahad Rafidah"],
  Tabuk: ["Tabuk", "Duba", "Umluj", "Haql", "Al Wajh", "Tayma"],
  Hail: ["Hail", "Baqaa", "Al Ghazalah", "Ash Shinan", "Mawqaq"],
  "Northern Borders": ["Arar", "Rafha", "Turaif", "Al Uwayqilah"],
  Jazan: ["Jazan", "Sabya", "Abu Arish", "Samtah", "Ahad al Masarihah", "Farasan", "Baish"],
  Najran: ["Najran", "Sharurah", "Hubuna", "Badr Al Janub", "Yadamah"],
  "Al Bahah": ["Al Bahah", "Baljurashi", "Al Mandaq", "Al Mikhwah", "Qilwah", "Al Aqiq"],
  "Al Jawf": ["Sakaka", "Dumat al-Jandal", "Al Qurayyat", "Tabarjal"],
  Qassim: ["Buraydah", "Unaizah", "Ar Rass", "Al Bukayriyah", "Al Mithnab", "Riyadh Al Khabra", "Al Badayea"],
};
